// @flow
import scrollIntoView from 'utils/scrollIntoView';
import { isIE11 } from 'utils/browser';

type PushAction = { type: 'PUSH_FLASH_MESSAGE', message: FlashMessageType };
type RemoveAction = { type: 'REMOVE_FLASH_MESSAGE', id: string };
type ClearAction = { type: 'CLEAR_FLASH_MESSAGES' };
export type Action = PushAction | RemoveAction | ClearAction;

export const pushFlashMessage = (
  message: FlashMessageType,
  immediateScroll?: boolean
): PushAction => {
  if (isIE11()) {
    if (immediateScroll) {
      window.scroll(0, 0);
    } else {
      scrollIntoView();
    }
  }
  return {
    type: 'PUSH_FLASH_MESSAGE',
    message
  };
};

export const removeFlashMessage = (id: string): RemoveAction => ({
  type: 'REMOVE_FLASH_MESSAGE',
  id
});

export const clearFlashMessages = (): ClearAction => ({
  type: 'CLEAR_FLASH_MESSAGES'
});
